import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { Game, GameStatuses, Tournament } from '@mtgame/core';
import { getGameRoute } from '@config/routes';
import { getTournamentShortName, getTourTitle } from '@utils/hardcode';

@Component({
  selector: 'mtg-game-headline-card',
  templateUrl: './game-headline-card.component.html',
  styleUrls: ['./game-headline-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameHeadlineCardComponent {
  @Input()
  game: Game;
  @Input()
  showGroup: boolean;
  gameStatuses = GameStatuses;

  get gameRoute(): string[] {
    return getGameRoute(this.game.id);
  }

  get currentPeriod(): number {
    return Object.keys(this.game.scoreByPeriod || {}).length || 1;
  }

  get tournamentName(): string {
    return getTournamentShortName(this.game.tournament.name);
  }

  getTourTitle(tour: number): string {
    return getTourTitle(tour, this.game.team.sport, true);
  }
}
